import api from '@pray/shared/utils/api';
import eventTracking from '@pray/shared/utils/eventTracking';
import logger from '@pray/shared/utils/logger';
import storage from '@pray/shared/utils/storage';

import { EVENTS, LOCAL_STORAGE } from 'constants.js';

async function getSubscriptionDetails() {
  try {
    const user = storage.getUser();
    const response = await api.executeGetRequest(`/web/users/${user.id}/subscription-details`);
    const subscriptionDetails = response.data.data;

    // update user subscribed state in localstorage
    if (user.is_subscribed !== subscriptionDetails.is_subscribed) {
      user.is_subscribed = subscriptionDetails.is_subscribed;
      storage.upsertToStorage(LOCAL_STORAGE.USER, user, false);
    }

    return subscriptionDetails;
  } catch (err) {
    logger.error('Failed to fetch user subscription details', err);
  }

  return null;
}

async function updateUser(id, data) {
  const response = await api.executePutRequest(`/0.13/users/${id}`, data);
  return response.data.data?.[0];
}

async function updateUserIntents(data) {
  const user = storage.getUser();
  const response = await api.executePostRequest(`/0.12/users/${user.id}/intents`, data);
  eventTracking.trackEventSubmitForm(EVENTS.PRAY_EVENTS.SUBMIT_FORM_EVENT_NAMES.INTENT, data);
  return response.data.data;
}

// Confirms ownership of an email address from the link in the verification email. Unauthenticated —
// the token in the link is the only proof, and it grants nothing beyond marking the email verified.
async function verifyEmail({ email, token }) {
  await api.executePostRequest('/web/verify_email', { email, token });
}

export default {
  getSubscriptionDetails,
  updateUser,
  updateUserIntents,
  verifyEmail,
};
